// Shared by navigation and route guards. Read access remains available to
// operational screens through the existing API permissions.
export const managementPermissions: Record<string, string[]> = {
  'template': ['template:create', 'template:edit', 'template:delete'],
  'activity_types': ['activity_types:create', 'activity_types:edit', 'activity_types:delete'],
  'canali': ['canali:create', 'canali:edit', 'canali:delete'],
  'settori': ['settori:create', 'settori:edit', 'settori:delete'],
  'leads:config': ['leads:config:edit'],
  'email_templates': ['email_templates:create', 'email_templates:edit', 'email_templates:delete'],
  'autorizzazioni': ['autorizzazioni:create', 'autorizzazioni:edit', 'autorizzazioni:delete'],
};
